function TextShapeModal() {

}

TextShapeModal.events = {
    isInit: true,

    init: function() {
        var self = this;

        if (self.isInit) {
            $("#prolook-textshape-modal").on("click", ".text-shape-item", self.onSelectShape);
            self.isInit = false;
        }
    },

    onSelectShape: function() {
        var layout = $(this).data("layout");
        var code = $(this).data("code");
        var type = $(this).data("type");
        var application = ub.funcs.getApplicationSettings(code);

        $("span.layout_name").data("layout", layout);
        $("span.layout_name").text(layout);

        if (layout === "arc") {
            TextShapeCore.customControllers.renderARC(application, application.application_type, layout);
        } 
        if (application.application_type !== TextShapeCore.TEXT_SHAPE_TYPE) {
            TextShapeCore.funcs.addTextShapeConfiguration(application, layout);
        } else {
            TextShapeCore.funcs.changeTextShape(application, layout);
        }

        UIkit.modal("#prolook-textshape-modal").hide();
    }
};

TextShapeModal.funcs = {
    loadTextShapeModal: function(code, type, current_layout, application_type) {
        var textShapeLayout = ub.data.textShapes.items;

        textShapeLayout = {
            application_type: application_type,
            type: type,
            code: code,
            layouts: [
                {
                    layout: TextShapeCore.TEXT_SHAPE_NONE,
                    layout_text: TextShapeCore.TEXT_SHAPE_NONE.toUpperCase(),
                    thumbnail: ub.config.host + '/prolook/img/text-shapes/none.png'   
                },
                {
                    layout: TextShapeCore.TEXT_SHAPE_ARC,
                    layout_text: TextShapeCore.TEXT_SHAPE_ARC.toUpperCase(),
                    thumbnail: ub.config.host + '/prolook/img/text-shapes/arc.png'   
                }
            ]
        };
        
        // Remove Arc in text_shape_categories for proper config
        ub.data.text_shapes_category.splice(4);


        // Add text shape categories
        _.map(ub.data.text_shapes_category, function(category) {
            textShapeLayout.layouts.push({
                layout: category.name,
                layout_text: category.name.toUpperCase(),
                thumbnail: ub.config.host + '/prolook/img/text-shapes/' + category.name + '.png'
            });
        });

        var template = document.getElementById("m-prolook-text-shape").innerHTML;
        var render = Mustache.render(template, textShapeLayout);

        $("#prolook-textshape-modal .text-shapes-main-container").html("");
        $("#prolook-textshape-modal .text-shapes-main-container").html(render);

        $("#prolook-textshape-modal a.text-shape-item.uk-active").parent().removeClass("uk-disabled");
        $("#prolook-textshape-modal a.text-shape-item.uk-active").removeClass("uk-active");

        $("#prolook-textshape-modal a.text-shape-item[data-layout='" + current_layout + "']").parent().addClass("uk-disabled");
        $("#prolook-textshape-modal a.text-shape-item[data-layout='" + current_layout + "']").addClass("uk-active");

        TextShapeModal.events.init();

        UIkit.modal("#prolook-textshape-modal").show();
    }
};